<script setup>
import { Link, usePage } from "@inertiajs/vue3";

const props = defineProps({
    href: {
        type: String,
        required: true,
    },
    active: {
        type: Boolean,
        required: false,
    },
    method: {
        type: String,
        required: false,
        default: "get",
    },
});

const availableLanguages = usePage().props.availableLanguages;
const currentTenant = usePage().props.currentTenant;
</script>

<template>
    <li class="xl:h-[68px] flex items-center">
        <Link
            class="group relative flex min-h-12 w-full gap-4 xl:min-h-10 xl:w-auto xl:gap-2 py-3 xl:py-2 px-3.5 items-center rounded-xl text-gray-600 hover:bg-gray-50 hover:text-gray-950 transition-all duration-300"
            :href="href"
            :method="method"
            :class="active ? 'text-theme-primary bg-theme-primary/10' : ''"
        >
            <slot />
            <span
                class="absolute left-3.5 right-3.5 bottom-1 h-0.5 rounded-full bg-theme-primary transition-all duration-300"
                :class="
                    active
                        ? 'opacity-100 scale-x-100'
                        : 'opacity-0 scale-x-75 group-hover:opacity-50 group-hover:scale-x-100'
                "
            />
        </Link>
    </li>
</template>

<style scoped></style>
